<script>
  import { status } from "./status.js";
  import page from "page";
  import { fancyAlert } from "./notification.js";
  import { registerSubscription } from "./apihandler.js";
  import { tl } from "./multilang.js";

  let id, email, password1, password2;

  async function registration() {
    
    registerSubscription(id, email, password1)
    .then(async () => {
      await fancyAlert("<p>"+tl("There are two additional steps required to finish setting up your subscription. After you receive the registration email:")+"</p><br /><p><b>"+tl('Step 1')+"</b><br/>"+tl('Click on the first link to confirm your registration.')+"</p><p><br /><b>"+tl('Step 2')+"</b><br />"+tl("From your mobile, and after installing the ZofToken app, click on the second link in the email and then create your PIN to set up your administrative token.")+"</p>", tl("Registration successful"), tl("Ok"), "NORMAL");
      page("/login");
    })
    .catch(async (error) => {
      if (error == 409) {
        await fancyAlert(tl("Duplicate subscription name and/or email"), tl("Registration failed"));
      } else if (error == 403) {
        await fancyAlert(tl("Invalid email address"), tl("Registration failed"));
      } else {
        await fancyAlert(error);
      }
    });
    
  }
</script>

<style type="text/css">

.content.for-free-label{
  background-image: url(../assets/for-free-label.svg);
  background-position: top right;
  background-repeat: no-repeat;
}
</style>

<section class=" has-background-grey-lightest	">
  <div class="container">

<div class="columns is-centered">
  <div class="column is-one-third">

    <div class="box content for-free-label">
      <h4>{tl("Get ZaaS for free!")}</h4>
      <p class="is-size-8">
        {tl("Already have an account?")}
        <a on:click={() => page('/login')}>{tl("Log in")}</a>
      </p>


      <div class="field">
        <label class="label">{tl("Email")}</label>
        <div class="control">
          <input class="input" type="text" bind:value={email} />
        </div>
      </div>

      <div class="field">
        <label class="label">{tl("Password")}</label>
        <div class="control">
          <input class="input" type="password" bind:value={password1} />
        </div>
      </div>

      <div class="field">
        <label class="label">{tl("Repeat password")}</label>
        <div class="control">
          <input class="input" type="password" bind:value={password2} />
        </div>
        <p
          class="help has-text-danger"
          class:is-invisible={!(password1 && password1 != password2)}>
          {tl("Passwords do not match")}
        </p>
      </div>

      <div class="field">
        <label class="label">{tl("Subscription name")}</label>
        <div class="control">
          <input class="input" type="text" bind:value={id} />
        </div>
        <p class="help">
          {tl("Cannot be changed later")}
      </p>
        <p
          class="help has-text-danger"
          class:is-invisible={!id || id.search(/ |_/) == -1}>
          {tl("Spaces and underscores are not allowed")}
        </p>
        <br />
      </div>

      <button
        class="button is-link is-fullwidth"
        disabled={!(id && id.search(/ |_/) == -1 && email && password1 && password1 == password2)}
        on:click={registration}>
        {tl("Register")}
      </button>

    </div>

  </div>

</div>
  </div>
</section>